import { IForumUser } from '@dtos/Comment'

export function displayName(
  user: IForumUser | null | undefined,
  fallback: string,
): string {
  if (!user) return fallback
  return (
    user.fullName ||
    [user.firstName, user.lastName].filter(Boolean).join(' ') ||
    user.email ||
    fallback
  )
}

export function authorInitials(
  user: IForumUser | null | undefined,
  fallback: string,
): string {
  const source = displayName(user, fallback)
  const parts = source.trim().split(/\s+/).slice(0, 2)
  return parts.map((p) => p.charAt(0).toUpperCase()).join('') || '?'
}
